import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import EventsStore from '../../stores/EventsStore'
import LoadingWrapper from '../../components/LoadingWrapper'
import { Divider, Grid, Header, List, Message } from 'semantic-ui-react'
import moment from 'moment'
import MenuEquipment from '../../components/Events/MenuEquipment'
import FormIndex from '../../components/Events/Forms/FormIndex'
import Toast from '../../components/Toast'
import MenuEvent from '../../components/Events/MenuEvent'

@inject('eventsStore')
@withRouter
@observer
class ArchivesEventScreen extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore).isRequired,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object
  }

  constructor (props) {
    super(props)
    if (!props.match.params.eventId) {
      props.history.goBack()
    }
    props.eventsStore.initLoading()
  }

  changeMenuType = (type, options) => {
    const { eventsStore } = this.props
    eventsStore.changeMenuType(type, options)
  }

  componentDidUpdate (prevProps) {
    const { eventsStore, location } = this.props
    // Check if we clicked back and we still in a event form
    const locationChanged = location !== prevProps.location
    if (locationChanged) {
      const searchParams = new URLSearchParams(location.search)
      if (searchParams.get('formcode') && searchParams.get('formcode') !== eventsStore.currentForm.code) {
        this.eventsStore.changeCurrentForm(searchParams.get('formcode'))
      }
    }
  }

  componentDidMount () {
    const { location, history, match, eventsStore } = this.props
    const searchParams = new URLSearchParams(location.search)
    const formcode = searchParams.get('formcode')
    eventsStore.loadFormArchive(match.params.eventId, formcode).then(() => {
      if (eventsStore.currentForm && formcode !== eventsStore.currentForm.code) {
        searchParams.set('formcode', eventsStore.currentForm.code)
        history.push({
          pathname: location.pathname,
          search: searchParams.toString()
        })
      }
    })
  }

  render () {
    const { eventsStore } = this.props
    const { isLoading, event, currentForm, equipmentWithErrors, toasts, showAllEquipment } = eventsStore
    if (isLoading) {
      return (<><LoadingWrapper loading={isLoading} message='Chargement en cours...' /></>)
    }
    return (
      <>
        <Toast toasts={toasts} />
        {!!event &&
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <Header
                  as='h1'
                  content={`Rapport d'inspection - ${event.clients_addresses_equipment.equipment.name}`}
                />
                {equipmentWithErrors.size > 0 && <Header.Subheader style={{ color: '#9f3a38', fontWeight: 700 }}>{equipmentWithErrors.size > 1 ? `${equipmentWithErrors.size} équipements avec erreurs` : '1 équipement avec erreurs'}</Header.Subheader>}
              </Grid.Column>

              <Grid.Column textAlign='right'>
                <List>
                  <List.Item>
                    {event.client.name}
                  </List.Item>
                  <List.Item>
                    {event.clients_addresses_equipment.clients_address.address.fullAddress}
                  </List.Item>
                  <List.Item>
                    {moment(event.date_start).format('HH:mm DD-MM-YYYY')}
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>}
        <MenuEvent readOnly />
        {!currentForm && <Message error>Aucun formulaire a été enregistré</Message>}
        {!!currentForm &&
          <>
            <MenuEquipment />
            <Divider className='thick' />
            {/** show all equipment for the form */}
            {!!currentForm && showAllEquipment && eventsStore.allEquipmentsFromCurrentForm.map(
              (formEntry, index) => {
                const Element = FormIndex[currentForm.code.replaceAll('-', '')]
                const lastElement = index === eventsStore.equipmentCount - 1
                return (
                  <Fragment key={`formEntry_${formEntry.id}`}>
                    <Element equipment={formEntry} changeMenuType={this.changeMenuType} />
                    {!lastElement && <Divider className='thick' />}
                  </Fragment>
                )
              }
            )}

            {/** show only one equipment for the form */}
            {React.createElement(FormIndex[currentForm.code.replaceAll('-', '')],
              {
                equipment: eventsStore.currentEquipment,
                changeMenuType: this.changeMenuType
              })}
          </>}
      </>
    )
  }
}

export default ArchivesEventScreen
